import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { useAuthGate } from './useAuthGate';

function ProtectedRoute({ children }) {
  const kind = useAuthGate();

  useEffect(() => {
    if (kind === 'forbidden') {
      void supabase.auth.signOut();
    }
  }, [kind]);

  if (kind === 'loading') {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: '#94a3b8', fontSize: '0.9rem' }}>
        Loading…
      </div>
    );
  }

  if (kind === 'barista') {
    return <Navigate to="/barista" replace />;
  }

  if (kind === 'mfa_required') {
    return <Navigate to="/login" replace state={{ mfaRequired: true }} />;
  }

  if (kind === 'delegate') {
    return children;
  }

  if (kind === 'anon' || kind === 'forbidden') {
    return (
      <Navigate
        to="/login"
        replace
        state={kind === 'forbidden' ? { adminOnly: true } : undefined}
      />
    );
  }

  return children;
}

export default ProtectedRoute;
